import fx from "utils/fx";
import AxiosInterceptor from "api/interceptor";

const product = new AxiosInterceptor();

export default {
  find(id) {
    return product.get("/product/detail/" + id);
  },
  get(qstr = {}, arr) {
    qstr = fx.urlQueryString(qstr, false);
    let url = qstr + "&";
    if (arr) {
      Object.keys(arr).map((va) => {
        url = url + fx.parameterizeArray(va, arr[va]);
      });
    }

    return product.get("/product?" + url);
  },
  getByCat(id) {
    return product.get("/product/category/" + id);
  },
  getByTag(id) {
    return product.get("/product/tag/" + id);
  },
  delete(id) {
    return product.delete("/product/" + id);
  },
  update(id, inputs) {
    return product.put("/product/" + id, {
      ...inputs,
      add_ons_list: inputs.add_ons_list || undefined,
      product_add_ons: inputs.product_add_ons || undefined,
      bundle_items: inputs.bundle_items.length != 0
        ? inputs.bundle_items
        : undefined,
    });
  },
  updateActive(id, inputs) {
    return product.put("/product/" + id, {
      name: inputs.name,
      image: inputs.image,
      price: inputs.price,
      quantity: inputs.quantity,
      content: inputs.content,
      units_in_stock: inputs.units_in_stock,
      type_id: inputs.type_id,
      supplier_id: inputs.supplier_id,
      tags: inputs.tags,
      categories: inputs.categories,
      attributes: inputs.attributes,
      featured: inputs.featured,
      galleries: inputs.galleries,
      is_active: inputs.is_active,
      is_sale_off: inputs.is_sale_off,
      original_price: inputs.original_price
    });
  },
  create(inputs) {
    return product.post("/product", {
      ...inputs,
      add_ons_list: inputs.add_ons_list || undefined,
      product_add_ons: inputs.product_add_ons || undefined,
      bundle_items: inputs.bundle_items.length != 0
        ? inputs.bundle_items
        : undefined,
    });
  },
  search(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return product.get("/product/search?" + qstr);
  },

  check(sku) {
    return product.get("/product/check/" + sku);
  },

  updateProductQuantity(list) {
    let data = {
      products: list
    };
    return product.put("/product/update_quantity", data);
  },

  setDisappear() {
    return product.put("/product/disappear");
  },
  setAppear() {
    return product.put("/product/appear");
  },

  searchAll(q = "") {
    return product.get("/product/search_all?q=" + q);
  },
  searchProduct(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return product.get("/product/search_all?" + qstr);
  },
  checkDisablePrice(id, arr) {
    let url = "";
    if (arr) {
      Object.keys(arr).map((va) => {
        url = url + fx.parameterizeArray(va, arr[va]);
      });
    }
    return product.get(`product/${id}/disable-fields?` + url);
  },
  searchAttributes(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return product.get("/attribute/search?" + qstr);
  },
  gerProductAddons(id) {
    return product.get("/product/product-add-ons/" + id);
  },
  getProductAddonsDefault() {
    return product.get("/product/add-ons-default");
  },
  getProductAddonsByCategory(arr) {
    let url;
    if (arr) {
      Object.keys(arr).map((va) => {
        url = fx.parameterizeArray(va, arr[va]);
      });
    }
    return product.get(`product/add-ons-default?` + url);
  }
};
